import { useEffect, useState } from 'react';

import Dialog, {
  DialogHeader,
  DialogContent,
  DialogFooter,
} from '@guestyci/foundation/Dialog';
import { Col, Row } from '@guestyci/foundation/Layout';
import TextField from '@guestyci/foundation/TextField';
import RaisedButton from '@guestyci/foundation/RaisedButton';
import t from '@guestyci/localize/t.macro';
import createStyles from '@guestyci/foundation/createStyles';
import history from '@guestyci/history';

import { useAppSelector } from 'store';
import { useAuthToken } from 'hooks/useAuthToken';

const useStyles = createStyles(({ breakpoints: { down } }) => ({
  root: {
    maxWidth: '500px',
    [down('sm')]: {
      minWidth: 'unset',
    },
  },
}));

const SessionChecker = () => {
  const classes = useStyles();
  const { decodedToken } = useAuthToken();

  const user = useAppSelector((state) => state.user);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (decodedToken?.userId !== user?._id) {
      setOpen(true);
    }
  }, [decodedToken, user]);

  const handleClose = () => {
    setOpen(false);
    history.replace('/');
  };

  return (
    <Dialog open={open} onClose={handleClose} noClear className={classes.root}>
      <DialogHeader>{t('Session update')}</DialogHeader>
      <DialogContent>
        <Col spacing={2}>
          <TextField variant="h5" color="secondary">
            {t(
              'Your active session has changed because you have impersonated a different owner.'
            )}
          </TextField>
          <TextField variant="h5" color="secondary">
            {t('New owner: {name}', { name: decodedToken?.name })}
          </TextField>
          <TextField variant="h5" color="secondary">
            {t('To continue with the new session, please refresh the page.')}
          </TextField>
        </Col>
      </DialogContent>
      <DialogFooter>
        <Row spacing={2} align="center" justify="end">
          <RaisedButton onClick={handleClose}>{t('Refresh')}</RaisedButton>
        </Row>
      </DialogFooter>
    </Dialog>
  );
};

export default SessionChecker;
